import { render, staticRenderFns } from "./Toggle.vue?vue&type=template&id=b4f3713a&scoped=true&"
import script from "./Toggle.vue?vue&type=script&lang=js&"
export * from "./Toggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f3713a",
  null
  
)

export default component.exports